import { Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  SelectInputComponent,
  TextInputComponent,
  CalendarInputComponent,
} from '@navstation-portal/shared/ui/components';
import { injectDispatch } from '@ngrx/signals/events';
import { PortsStore } from '@navstation-portal/ports/data-access/store';
import { portsToSelectOptions } from '@navstation-portal/ports/util/ports';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { TIMEZONE_SELECT_OPTIONS } from '@navstation-portal/shared/util/time';

@Component({
  selector: 're-voyage-details',
  templateUrl: './voyage-details.component.html',
  imports: [
    TextInputComponent,
    SelectInputComponent,
    FormsModule,
    CalendarInputComponent,
    IsVisibleDirective,
  ],
})
export class VoyageDetailsComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'voyageDetails';
  events = injectDispatch(offshoreOperationalEvents);
  portsStore = inject(PortsStore);
  offshoreOperationalStore = inject(OffshoreOperationalFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
  timezoneOptions = TIMEZONE_SELECT_OPTIONS;
  portOptions = computed(() => {
    return portsToSelectOptions(this.portsStore.ports());
  });
}
